import { EXPANDED_FIXED_SIDEBAR } from '../component/layout/constants';
import {
  LAYOUT_CLASSES,
  LAYOUT_VARS,
  TinyToolbarContainerProps,
  LAYOUT_VALS,
} from './common.constants';

export const TOKENS_CSS = `
  .${LAYOUT_CLASSES.layout}  {
    ${LAYOUT_VARS.maintenanceHeight}: 0px;
    ${LAYOUT_VARS.bannerHeight}: 0px;
    ${LAYOUT_VARS.headerHeight}: 55px;
  }
  .${LAYOUT_CLASSES.withMaintenanceBar} {
    ${LAYOUT_VARS.maintenanceHeight}: 30px;
  }
`;

export const PROJECT_CSS = [
  /* css */ `
  body {
    overflow: hidden;
  }
`,

  TOKENS_CSS,

  /* Layout co-writer defined init values  */
  `
  .${LAYOUT_CLASSES.layoutCoWriter} {
    ${LAYOUT_VARS.logoBrandSize}: ${100}px;
    ${LAYOUT_VARS.drawerMenubarHeight}: 42px;;
    ${LAYOUT_VARS.menubarHeight}: 42px;
    ${LAYOUT_VARS.toolbarHeight}: 40px;
    ${LAYOUT_VARS.headerHeight}: calc(${LAYOUT_VALS.menubarHeight} + ${LAYOUT_VALS.toolbarHeight});
    ${LAYOUT_VARS.headerPaddingX}: 12px;
    ${LAYOUT_VARS.headerPaddingY}: 8px;
    ${LAYOUT_VARS.drawerWidth}: ${EXPANDED_FIXED_SIDEBAR}px;
  }`,
  /* Injector DIV takes full spacing with potsition realtive to app-bar header. */
  /* pointer-events: none; This make sure that div itself is tarnsparent to events */

  `
  #${TinyToolbarContainerProps.id} {
    flex-basis: 100%;
    min-height: 
    position: absolute;
    pointer-events: none;
    font-family: Open Sans !important;
  }`,
  /*  tiny container for menubar and toolbar */
  /*  background reset: This is a safe measure to make sure the menubar and toolbar wraps if width is small default applies white background, we negate it. */
  `
  #${TinyToolbarContainerProps.id} .tox.tox-tinymce.tox-tinymce-inline {
    background: none;
  }`,
  /* .className.className has higher precedence over .className */
  /* min-height: ${LAYOUT_VALS.menubarHeight}; menubar has its own defined height we make sure it expands to take up that height */
  /* margin-left: ${LAYOUT_VALS.fileMenuShift}; logo on left with file will shift the menu bar, extra 8px is for safe keeping, LAYOUT.VALS.fileMenuShift */
  `
  #${TinyToolbarContainerProps.id} .tox-menubar.tox-menubar { 
    min-height: ${LAYOUT_VALS.menubarHeight};
    margin-left: ${LAYOUT_VALS.fileMenuShift};
    padding: ${LAYOUT_VALS.headerPaddingY} ${LAYOUT_VALS.headerPaddingX};
    background: none;
    border: none;
  }`,
  /** toolbar must have assumed height */
  `
  #${TinyToolbarContainerProps.id} .tox-toolbar-overlord,
  #${TinyToolbarContainerProps.id} .tox-toolbar__primary {      
    min-height: ${LAYOUT_VALS.toolbarHeight};
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    background: none;
    border: none;
  }`,
  /** standard padding */
  `
  #${TinyToolbarContainerProps.id} .tox-toolbar__primary {
    padding-left: 0px;
    padding-right: 0px;
    pointer-events: auto;
  } `,

  /** tox button toolbar: make each button height 24px */
  // `
  // #${TinyToolbarContainerProps.id} button.tox-tbtn, div.tox-split-button {
  //   height: 24px;
  // }`,

  /** tox button toolbar: make each button height 24px */
  // `
  //   #${TinyToolbarContainerProps.id} .tox-toolbar__group  {
  // height: 100%;
  //   }`,

  /** tox button toolbar: make each button height 24px */
  // `
  //   #${TinyToolbarContainerProps.id} .tox-toolbar__group .tox-split-button  {
  //     height: 100%;
  //   }`,

  /* This will make sure button do recive pointer events as unset on parent */
  `
  #${TinyToolbarContainerProps.id} button, div[role="menu"] {
    pointer-events: auto;
    font-family: Open Sans;
  }`,

  /* File menu button styling */
  `
  #${TinyToolbarContainerProps.id} .tox-menubar button.tox-mbtn {
    height: 24px;
    padding: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-right: 4px;
    background-color: none;
    fontSize: 12px;
    color: #686868;
    font-family: Open Sans;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-dialog {
    pointer-events: auto;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-split-button {
    pointer-events: auto;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-button {
    background-color: #499557;
    border-color: #499557;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-button--secondary {
    background-color: inherit;
    border-color: #499557;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-button--naked {
    background-color: inherit;
    border-color: #499557;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-dialog__body-nav-item--active {
    color: #499557;
    border-bottom-color: #499557;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-listbox--select:focus, .tox-textarea:focus, .tox-textfield:focus {
    border-color: #499557;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-textfield.tox-textfield:focus {
    border-color: #499557;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-pop__dialog {
    width: max-content;
  }`,

  `#${TinyToolbarContainerProps.id} .tox-collection__group.tox-collection__group{
    min-width: 160px !important;
  }`,
].join('');
